import React from 'react';
import BackButton from '../components/BackButton';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';

export default function Terminos() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 md:px-6 max-w-3xl py-12">
        <BackButton />
        <h1 className="text-4xl font-heading font-bold text-[#134168] mb-2">{t('legal.terms.title')}</h1>
        <p className="text-sm text-gray-400 mb-8">{t('legal.lastUpdatedMay')}</p>

        <div className="bg-white rounded-3xl p-8 shadow-sm space-y-6 text-gray-700 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.terms.s1Title')}</h2>
            <p>{t('legal.terms.s1Text')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.terms.s2Title')}</h2>
            <p>{t('legal.terms.s2Text')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.terms.s3Title')}</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>{t('legal.terms.s3I1')}</li>
              <li>{t('legal.terms.s3I2')}</li>
              <li>{t('legal.terms.s3I3')}</li>
              <li>{t('legal.terms.s3I4')}</li>
              <li>{t('legal.terms.s3I5')}</li>
            </ul>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.terms.s4Title')}</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>{t('legal.terms.s4I1')}</li>
              <li>{t('legal.terms.s4I2')}</li>
              <li>{t('legal.terms.s4I3')}</li>
              <li>{t('legal.terms.s4I4')}</li>
            </ul>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.terms.s5Title')}</h2>
            <p>{t('legal.terms.s5Text')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.terms.s6Title')}</h2>
            <p>{t('legal.terms.s6Text')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.terms.s7Title')}</h2>
            <p>{t('legal.terms.s7Text')} <a href="mailto:info@redmobility.com" className="text-[#134168] hover:underline">info@redmobility.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
